/* eslint-disable no-unused-expressions */
import axios from "axios"
import headers from "../../util/headers"

export const getLearnWorldProduct = baseUrl => {
  const path = `${baseUrl}/backend/learn_world_products`
  return axios.get(path, { ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}